// extracted by mini-css-extract-plugin
module.exports = {"container":"Logo_container__2oZgI","logo_image":"Logo_logo_image__2_vyq"};